export default __webpack_public_path__ + "images/KR.dbaab86.png";